import OrderForwardListRequest, {
  OrderForwardListRequestOrder,
} from "../../../api/raily/order-forward/list/order-forward-list.request";
import OrderForwardListParams, {
  OrderForwardListParamsOrder,
} from "./order-forward-list-params";

const createOrder = (
  order: OrderForwardListParamsOrder | undefined,
): OrderForwardListRequestOrder | undefined => {
  switch (order) {
    case OrderForwardListParamsOrder.CONSUMER_ASC:
      return OrderForwardListRequestOrder.CONSUMER_ASC;
    case OrderForwardListParamsOrder.CONSUMER_DESC:
      return OrderForwardListRequestOrder.CONSUMER_DESC;
    case OrderForwardListParamsOrder.PRODUCER_ASC:
      return OrderForwardListRequestOrder.PRODUCER_ASC;
    case OrderForwardListParamsOrder.PRODUCER_DESC:
      return OrderForwardListRequestOrder.PRODUCER_DESC;
    default:
      return undefined;
  }
};

const create = (params: OrderForwardListParams): OrderForwardListRequest => {
  return {
    address: params.address,
    consumer: params.consumer,
    driver: params.driver,
    endAddress: params.endAddress,
    externalId: params.externalId,
    humanId: params.humanId,
    limit: params.limit,
    midAddress: params.midAddress,
    offset: params.offset,
    order: createOrder(params.order),
    passenger: params.passenger,
    producer: params.producer,
    startAddress: params.startAddress,
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
  };
};

const orderForwardListParamsFactory = {
  create,
};

export default orderForwardListParamsFactory;
